import {
  CalendarOutlined,
  CheckSquareOutlined,
  ContainerOutlined,
  DownOutlined,
  LaptopOutlined,
  PieChartOutlined,
  ToolOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { Dropdown, Space } from "antd";
import { useNavigate, Link, useLocation } from "react-router-dom";
import useProfileData from "../../hooks/useProfileData";

export default function DarNavbar() {
  const { profileData } = useProfileData();
  const reviewFormLink = (profileData.appraisalFormId) ?
    (profileData.appraisalFormId === 1) ? `Appraisal/1?EmpId=${profileData.loginId}` :
      (profileData.appraisalFormId === 2) ? `Appraisal/2?EmpId=${profileData.loginId}` :
        (profileData.appraisalFormId === 3) ? `Appraisal/3?EmpId=${profileData.loginId}` :
          (profileData.appraisalFormId === 5) ? `Appraisal/5?EmpId=${profileData.loginId}` :
            'Appraisal/Not-Found' :
    'Appraisal/Not-Found'
  const userData = JSON.parse(localStorage.getItem("userData"));
  const probationInfo = JSON.parse(localStorage.getItem("probationInfo"));
  const onClick = ({ key }) => {
    // message.info(`Click on item ${key}`);
    navigate(`/${key}`, { replace: true });
  };
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const items = [
    {
      label: "DAR Summary",
      key: "DarSummary",
    },
    {
      label: "DAR Entry",
      key: "AddDar",
    },
    (userData.reportingHeadId) && {
      label: "Forecast",
      key: "Forecast",
    }
  ];

  const weeklyItems = [
    {
      label: "Weekly Activity",
      key: "ViewActivityreport",
    },
  ];

  const order = [
    {
      label: "Order Processing",
      key: "OrderDefault",
    },
  ];
  const reports = [
    {
      label: "Activity Report",
      key: "DailyActivityReport",
    },
    {
      label: 'Employees Graph',
      key: 'Dar/EmployeesGraph'
    }
  ];
  const attendance = [
    {
      label: "Mark Attendance",
      key: "Attendance/MarkAttendance",
    },
    {
      label: "Attendance Report",
      key: "Attendance/AttendanceList",
    },
    {
      label: "Request Leave",
      key: "Attendance/RequestLeave",
    },
    {
      label: "Leave History",
      key: "Attendance/LeaveHistory",
    },
    {
      label: "Subordinates Leave History",
      key: "LeaveDetail/SubordinateLeaveHistory"
    }
    // {
    //     label: 'Attendance Report',
    //     key: 'Attendance/AttendanceReport'
    // },
    // {
    //     label: 'Absent Report',
    //     key: 'Attendance/AbsentReport'
    // }
  ];
  const projectItems = [
    {
      label: "Manage Project Type",
      key: "Projects/ManageProjectType",
    },
    {
      label: "Manage Project",
      key: "Projects/ManageProject",
    },
    {
      label: "Project Allocate",
      key: "Projects/ProjectAllocation",
    },
    {
      label: "Approve Project Activity",
      key: "Projects/ApprovedActivity",
    },
    {
      label: "Project Reports",
      key: "Projects/Reports"
    }
  ];

  const reviewAndPerformace = [
    {
      label: "My Review Form",
      key: reviewFormLink,
    },
    {
      label: "Manager Audit",
      key: "Appraisal/ManagerAuditEmpList",
    }
  ];

  const reimbursement = [
    {
      label: "Reimbursement",
      key: "Reimbursement",
    },
    {
      label: "List",
      key: 'Reimbursement/List'
    }
  ]

  const userProjectItems = [
    {
      label: "Assinged Projects",
      key: "Projects/AssignedProject",
    },
    {
      label: "Activity Status",
      key: "Projects/ActivityStatus",
    },
  ];

  const training = [
    {
      label: 'Training Feedback',
      key: 'Training/Feedback'
    },
    {
      label: "Suggesstions",
      key: 'Training/Suggestions'
    },
    {
      label: 'Training Details',
      key: 'Training/Details'
    }
  ];

  const Kras = [
    {
      label: "My KRA",
      key: "MyKRAForm"
    },
    {
      label: "Approve KRA",
      key: "ManagerKRAapproval"
    },
  ];

   const weeklyActivityList = [
    {
      label: "Weekly Activity",
      key: "ViewActivityreport",
    },
    {
      label: "Weekly Activity Report",
      key: "ApproveWeeklyActivity",
    },
  ];

  const info = [
    {
      label: "Subordinate Resignation List",
      key: "ResignationInfo/ReportingHeadList",
      isVisible: userData.isReportingHead
    },
    {
      label: "Resignation Status",
      key: "ResignationInfo/ResignationStatus",
      isVisible: userData.isResigned
    }
  ].filter(item => item.isVisible);

  return (
    <div className="dropdown-navbar">
      <Dropdown
        menu={{
          items,
          onClick,
        }}
      >
        <a
          onClick={(e) => e.preventDefault()}
          style={{ color: "black", fontSize: "13px", fontWeight: 600 }}
        >
          <Space>
            <CalendarOutlined />
            DAR
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>

      <Dropdown
        className="mx-3"
        menu={{
          items: Kras,
          onClick,
        }}
      >
        <a
          onClick={(e) => e.preventDefault()}
          style={{ color: "black", fontSize: "13px", fontWeight: 600 }}
        >
          <Space>
            <PieChartOutlined />
            KRA
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>
        {userData?.isReportingHead ? (
        <Dropdown
          className="mx-2"
          menu={{
            items: weeklyActivityList,
            onClick,
          }}
        >
          <a
            onClick={(e) => e.preventDefault()}
            style={{
              color: "black",
              fontSize: "13px",
              fontWeight: 600,
            }}
          >
            <Space>
              <PieChartOutlined />
              Weekly Activity
              <DownOutlined />
            </Space>
          </a>
        </Dropdown>
      ) :
      <Dropdown
          className="mx-2"
          menu={{
            items: weeklyItems,
            onClick,
          }}
        >
          <a
            onClick={(e) => e.preventDefault()}
            style={{
              color: "black",
              fontSize: "13px",
              fontWeight: 600,
            }}
          >
            <Space>
              <PieChartOutlined />
              Weekly Activity
              <DownOutlined />
            </Space>
          </a>
        </Dropdown>}
      <Dropdown
        className="mx-3"
        menu={{
          items: [
            {
              label: "Create Quotation",
              key: "CreateQuotation",
            },
            {
              label: "Quotation List",
              key: "QuotationList",
            },
          ],
          onClick,
        }}
      >
        <a
          onClick={(e) => e.preventDefault()}
          style={{ color: "black", fontSize: "13px", fontWeight: 600 }}
        >
          <Space>
            <ToolOutlined />
            Quotation
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>

      {/* <Dropdown
        menu={{
          items: weeklyItems,
          onClick,
        }}
      >
        <a
          onClick={(e) => e.preventDefault()}
          style={{ color: "black", fontSize: "13px", fontWeight: 600 }}
        >
          <Space
            style={{
              marginRight: "6px",
            }}
          >
            <ToolOutlined />
            Weekly Plan
            <DownOutlined />
          </Space>
        </a>
      </Dropdown> */}

      <Dropdown
        menu={{
          items: reports,
          onClick,
        }}
      >
        <a
          onClick={(e) => e.preventDefault()}
          style={{ color: "black", fontSize: "13px", fontWeight: 600 }}
        >
          <Space>
            <ContainerOutlined />
            Reports
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>
      {userData.isAppEng && (
        <Dropdown
          menu={{
            items: order,
            onClick,
          }}
        >
          <a
            onClick={(e) => e.preventDefault()}
            style={{ color: "black", fontSize: "13px", fontWeight: 600 }}
          >
            <Space>
              <ToolOutlined />
              Order
              <DownOutlined />
            </Space>
          </a>
        </Dropdown>
      )}
      {pathname.includes("/Attendance") && (
        <Dropdown
          menu={{
            items: attendance,
            onClick,
          }}
        >
          <a
            onClick={(e) => e.preventDefault()}
            style={{
              color: "black",
              fontSize: "13px",
              fontWeight: 600,
              marginLeft: "0.75rem",
            }}
          >
            <Space>
              <ToolOutlined />
              Attendance Details
              <DownOutlined />
            </Space>
          </a>
        </Dropdown>
      )}
      {
        <Link
          to="/PriceList"
          style={{
            color: "black",
            fontSize: "13px",
            fontWeight: 600,
            marginLeft: "0.75rem",
          }}
        >
          <Space>
            <WalletOutlined />
            Price List
          </Space>
        </Link>
      }
      {
        <Link
          to="/ReportingHeadConfirmation"
          style={{
            color: "black",
            fontSize: "13px",
            fontWeight: 600,
            marginLeft: "0.75rem",
          }}
        >
          <Space>
            <CheckSquareOutlined />
            Emp Confirmation
          </Space>
        </Link>
      }
      {(userData?.loginId === 163 || userData?.loginId === 6) && (
        <>
          <Dropdown
            menu={{
              items: projectItems,
              onClick,
            }}
          >
            <a
              onClick={(e) => e.preventDefault()}
              style={{
                color: "black",
                fontSize: "13px",
                fontWeight: 600,
                marginLeft: "0.75rem",
              }}
            >
              <Space>
                <ToolOutlined />
                Project
                <DownOutlined />
              </Space>
            </a>
          </Dropdown>
          <Link
            to="/Order/Details/List"
            style={{
              color: "black",
              fontSize: "13px",
              fontWeight: 600,
              marginLeft: "0.75rem",
            }}
          >
            <Space>
              <ToolOutlined />
              Order Details
            </Space>
          </Link>
        </>

      )}

      {(userData?.loginId === 163) && (

        <Link
          to="/ITEquipment"
          style={{
            color: "black",
            fontSize: "13px",
            fontWeight: 600,
            marginLeft: "0.75rem",
          }}
        >
          <Space>
            <LaptopOutlined />
            IT Equipment Inventory
          </Space>
        </Link>
      )}
    {(userData?.loginId === 6 || userData?.loginId === 3 || userData?.loginId === 10) && (

        <Link
          to="/TargetsOverview"
          style={{
            color: "black",
            fontSize: "13px",
            fontWeight: 600,
            marginLeft: "0.75rem",
          }}
        >
          <Space>
            <LaptopOutlined />
            TargetsOverview
          </Space>
        </Link>
      )}

      {(userData?.loginId === 163) && (

        <Link
          to="/QPI/List"
          style={{
            color: "black",
            fontSize: "13px",
            fontWeight: 600,
            marginLeft: "0.75rem",
          }}
        >
          <Space>
            <LaptopOutlined />
            QPI Calculator
          </Space>
        </Link>
      )}
      <Dropdown
        menu={{
          items: reviewAndPerformace,
          onClick,
        }}
      >
        <a
          onClick={(e) => e.preventDefault()}
          style={{
            color: "black",
            fontSize: "13px",
            fontWeight: 600,
            marginLeft: "0.75rem",
          }}
        >
          <Space>
            <ToolOutlined />
            Review
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>

      {/* <Dropdown
        menu={{
          items: reimbursement,
          onClick,
        }}
      >
        <a onClick={(e) => e.preventDefault()} style={{ color: 'black', fontSize: '13px', fontWeight: 600 }}>
          <Space>
            <ToolOutlined />Reimbursement<DownOutlined />
          </Space>
        </a>
      </Dropdown> */}
      {
        probationInfo && probationInfo?.isOnProbation && !(userData.isResigned) && (
          <Link
            to="/Confirmation/CheckProbation"
            style={{
              color: "black",
              fontSize: "13px",
              fontWeight: 600,
              marginLeft: "0.75rem",
            }}
          >
            <Space>
              <CheckSquareOutlined />
              Probation
            </Space>
          </Link>
        )
      }

      {
        info.length > 0 && (
          <Dropdown
            menu={{
              items: info,
              onClick,
            }}
          >
            <a
              onClick={(e) => e.preventDefault()}
              style={{
                color: "black",
                fontSize: "13px",
                fontWeight: 600,
                marginLeft: "0.75rem",
              }}
            >
              <Space>
                <ToolOutlined />
                Info
                <DownOutlined />
              </Space>
            </a>
          </Dropdown>
        )
      }

      {/* <Dropdown
        menu={{
          items: training,
          onClick,
        }}
      >
        <a onClick={(e) => e.preventDefault()} style={{ color: 'black', fontSize: '13px', fontWeight: 600 }}>
          <Space>
            <ToolOutlined />Training<DownOutlined />
          </Space>
        </a>
      </Dropdown> */}

      {/* <Link
          to="/WeeklyReport"
          style={{
            color: "black",
            fontSize: "13px",
            fontWeight: 600,
            marginLeft: "0.75rem",
          }}
        >
          <Space>
            <TbReport />
            Weekly Report
          </Space>
      </Link> */}
      <Link
        to="/Order/Pipeline/List"
        style={{
          color: "black",
          fontSize: "13px",
          fontWeight: 600,
          marginLeft: "0.75rem",
        }}
      >
        <Space>
          <WalletOutlined />
          Order Pipeline
        </Space>
      </Link>
    </div>
  );
}
